"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.registerDependencies = void 0;

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _mergeWith2 = _interopRequireDefault(require("lodash/mergeWith"));

// eslint-disable-next-line consistent-return
function mergeArrays(objValue, srcValue) {
  if ((0, _isArray2["default"])(objValue) && (0, _isArray2["default"])(srcValue)) {
    return objValue.concat(srcValue);
  }
}

var dependencies = {};

var registerDependencies = function registerDependencies(dep) {
  return (0, _mergeWith2["default"])(dependencies, dep, mergeArrays);
};

exports.registerDependencies = registerDependencies;
var _default = dependencies;
exports["default"] = _default;